export default class ModalMenuList {
    constructor($el) {
        this.$el = $el;
        this.type = this.$el.dataset.modalMenu
        this.animation = document.querySelector(`[data-modal-menu-animation="${this.type}"]`);
        this.icon = document.querySelector(`[data-modal-icon-trigger="${this.type}"]`);

        this.close = this.close.bind(this);

        this.$el.addEventListener('mouseleave', this.close);
    }

    close() {
        this.$el.classList.remove('modal-menu--open');

        if(this.animation) {
            this.animation.classList.remove('animation');
        }

        if(this.icon) {
            this.icon.classList.remove('animate');
        }

        const event = new CustomEvent('remove-category-list');
        window.dispatchEvent(event);

    }
}